import React from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, Assignment } from '@material-ui/icons';

import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import ModalSaleForceDetail from './Modal';
import { useModal } from 'hooks/useModal';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. Vdor', accessor: 'SlpCode' },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'Cód. Canal', accessor: 'base_canal_code' },
  { Header: 'Canal', accessor: 'base_canal_description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();

  const { id, showNotify, sfDetails, reload } = props;
  const [model, setOpen] = useModal();

  return (
    <>
      <ModalSaleForceDetail
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={reload}
        idSaleForce={id}
      />

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.BASE_SALE_FORCE_DETAILS_STORE}
            component={
              <CardIcon color="primary">
                <Assignment style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Detalles de la fuerza de venta</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="Detalles-de-ferza-de-venta"
            defaultWidth={900}
            indexRow={[0, 1, 3, 5, 6]}
            widthRow={[130, 100, 120, 120, 0]}
            columns={columns}
            data={
              sfDetails?.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_SALE_FORCE_DETAILS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_SALE_FORCE_DETAILS_DELETED}
                      >
                        <ButtonDelete
                          entity="base/sale-force-detail"
                          id={item.id}
                          reload={reload}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  SlpCode: item.SlpCode,
                  SlpName: item.SlpName,
                  base_canal_code: item.base_canal_code,
                  base_canal_description: item.base_canal_description,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
